export const GRID_COLUMNS = '1fr 1fr 1fr 1fr';
